import { AssetTypeAPI, AssetTypeURI } from '@mss/mss-component-library';

export const assetTypeURIToAPI: Record<AssetTypeURI, AssetTypeAPI> = {
  assetmanagement: 'asset_management',
  security: 'application',
  control: 'control',
  analyzermanagement: 'analyzer_management',
  compute: 'compute',
  field: 'field',
  plcdcs: 'dcs_plc',
  env: 'env',
  network: 'network',
  virtualization: 'virtualization',
};

export const assetTypeAPItoURI: Record<AssetTypeAPI, AssetTypeURI> =
  Object.entries(assetTypeURIToAPI).reduce(
    (acc, [key, val]) => ({
      ...acc,
      [val]: key as AssetTypeURI,
    }),
    {} as Record<AssetTypeAPI, AssetTypeURI>
  );

export const configType = (assetType: AssetTypeAPI) => {
  switch (assetType) {
    case 'analyzer_management':
    case 'asset_management':
    case 'control':
    case 'application':
    case 'virtualization':
      return 'application';
    case 'compute':
    case 'dcs_plc':
    case 'network':
    case 'env':
    case 'field':
    default:
      return 'asset';
  }
};
